import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Get the current timezone of the browser
    this.browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.element.value = this.browserTimeZone;
  }
}